<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-title>Módulo de monitoreo</app-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <router-view></router-view>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        //
    }),
    computed: {
        //
    },
    methods: {
        //
    },
}
</script>
